import { useState, useCallback, useMemo } from 'react';
// @ts-expect-error Because it is an configuration file
import tailwindConfig from '../../tailwind.config.js';

const screens = tailwindConfig.theme.screens;

export const useResize = (aspectRatio: number = 16 / 9, maxWidth: number = 1600) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  const maxHeight: number = useMemo(() => {
    return maxWidth / aspectRatio;
  }, [aspectRatio, maxWidth]);

  const resizeHandler = useCallback(() => {
    const newHeight = window.innerWidth / aspectRatio;
    const calculatedHeight = Math.min(newHeight > window.innerHeight ? window.innerHeight : newHeight, maxHeight);
    const calculatedWidth = Math.min(calculatedHeight * aspectRatio, maxWidth);
    setSize({
      width: calculatedWidth,
      height: calculatedHeight,
    });
  }, [aspectRatio, maxWidth, maxHeight]);

  const getCurrentSizeStyle = useCallback(
    (tailwindStyle: string) => {
      if (!tailwindStyle) {
        return '';
      }

      let matchedStyle = '';
      const screenKeys = Object.keys(screens).sort((a, b) => parseInt(screens[a]) - parseInt(screens[b]));

      for (let i = screenKeys.length - 1; i >= 0; i--) {
        const screen = screenKeys[i];
        const screenWidth = parseInt(screens[screen]);

        if (size.width >= screenWidth) {
          const regex = new RegExp(`${screen}:([^\\s]+)`);
          const styleMatch = tailwindStyle.match(regex)?.[1];

          if (styleMatch) {
            matchedStyle = styleMatch;
            break;
          }
        }
      }

      return matchedStyle || tailwindStyle.split(' ')[0];
    },
    [size]
  );

  return {
    size,
    resizeHandler,
    getCurrentSizeStyle,
  };
};
